const TEALIUM_CUSTOM_EVENT = 'gv:onTealiumEvent';

export { TEALIUM_CUSTOM_EVENT };
//# sourceMappingURL=constants.js.map
